import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AuthenticationService } from 'src/app/pages/auth/services/authentication.service';
import { AuthService } from '../../../../abstraction/auth.service';
import { IUserInfoField } from '../../../../models/User';
import errors from '../../../../utils/errorCodes';
import {
  AlertDialogComponent,
  AlertDialogData,
} from 'src/app/modules/shared/components/dialogs/alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-edit-number-dialog',
  templateUrl: './edit-number-dialog.component.html',
  styleUrls: ['./edit-number-dialog.component.scss'],
})
export class EditNumberDialogComponent implements OnInit {
  phoneControl: FormControl;
  isLoading = false;

  constructor(
    private authSvc: AuthService,
    public authentication: AuthenticationService,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<EditNumberDialogComponent>,
  ) {
    this.phoneControl = new FormControl('', [
      Validators.required,
      this.phoneLengthValidator.bind(this),
    ]);
  }

  ngOnInit(): void {}

  validateInfo() {
    this.phoneControl.markAsTouched();
    this.phoneControl.markAsDirty();
    return this.phoneControl.valid;
  }

  updateUserInfo() {
    if (!this.validateInfo()) return;
    this.isLoading = true;
    const phone = this.phoneControl;
    const newInfo: IUserInfoField = {};
    newInfo.phoneNumber = phone.value;

    this.authentication.infoUpdate(newInfo).subscribe(
      () => {
        this.authSvc.loggedUser.phoneNumber = newInfo.phoneNumber;
        this.authSvc.loggedUserObs.next(this.authSvc.loggedUser);
        this.isLoading = false;
        this.dialogRef.close(true);
      },
      (err) => {
        this.isLoading = false;
        if (err.error.internalStatus) {
          this.dialog.open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
            panelClass: 'modal-container',
            data: {
              title: 'No se pudo actualizar tus datos',
              content: `Ocurrió un error desconocido. Te pedimos por favor que te contactes por el chat para ayudarte a resolver el problema.`,
              isError: true,
              errorCode: err.error.internalStatus,
            },
          });
        }
      },
    );
  }

  getErrorMessage() {
    const keys = Object.keys(this.phoneControl.errors);
    if (keys.length === 0) {
      return '';
    }
    return errors[keys[0]];
  }

  phoneLengthValidator(control: AbstractControl): { [key: string]: boolean } | null {
    if (control.value && control.value.toString().length < 10) {
      return { phoneShort: true };
    }
    return null;
  }
}
